export default __webpack_public_path__ + "static/media/mapimage.ab399b72.png";